export default {
  'Animate old photos': 'Activez de vieilles photos',
  'Animate faces in your photos with AI technology, create vivid videos.':
    "Animez les visages de vos photos grâce à la technologie de l'IA et créez des vidéos vivantes.",
  'Upload a photo': 'Téléchargez une photo',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    "Remarque : veillez à ce que le visage des photos que vous avez sélectionnées soit face à l'objectif, sinon elles ne pourront pas être traitées avec succès.",
  'Uploaded successfully!': 'Téléchargé avec succès !',
  'Please select a template below':
    'Veuillez sélectionner un modèle ci-dessous',
  'Choose a GIF': 'Choisissez un GIF',
  'Use this template': 'Utilisez ce modèle',
  'Verify successfully! You will':
    'Vérifier avec succès ! Vous recevrez bientôt la vidéo avec {{email}}.',
  'You will': 'Vous recevrez bientôt la vidéo avec {{email}}.',
  'What you should expect to happen next':
    'Ce que vous devez attendre de la suite :',
  'We will process your photo into a dynamic video.':
    'Nous allons transformer votre photo en une vidéo dynamique.',
  'After processing, we will send the video to your email.':
    'Après le traitement, nous enverrons la vidéo à votre adresse électronique.',
  'You can check the video in your email.':
    'Vous pouvez vérifier la vidéo dans votre e-mail.',
  'Your video will be delivered via email':
    'Votre vidéo sera livrée par e-mail',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Il faut 20-30 minutes pour synthétiser une vidéo dynamique, veuillez être patient. Pour protéger votre vie privée, les photos téléchargées seront automatiquement supprimées une fois le traitement terminé.',
  'Your Email': 'Votre e-mail',
  'Last Name': 'Votre prénom',
  'First Name': 'Nom de famille',
  'Go back': 'Retourner',
  'Invalid email address': 'Adresse e-mail invalide.',
  'Enter verification code': 'Saisissez le code de vérification',
  'Enter the verification code that we sent to':
    'Saisissez le code de vérification que nous avons envoyé à {{email}}.',
  Resend: 'Renvoyez',
  'Verification code': 'Code de vérification',
  'Resend after': 'Renvoyez après {{num}}s',
  'The verification code is invalid. You can request a new one.':
    'Le code de vérification est invalide. Vous pouvez en demander un nouveau.',
  'Synthesize Video': 'Synthétiser la vidéo',
  Next: 'Suivant',
  'Too many attempts, please try again later.':
    'Trop de tentatives, Veuillez réessayer plus tard.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
